export default __webpack_public_path__ + "static/media/appsMenu.b71d65ff.svg";